<div [ngClass]="langDirection">
  <mi-request></mi-request>
  <mc-dialog [dialogProperties]="dialogService.dialog()"></mc-dialog>
</div>